import { Reveal } from "@/components/motion/Reveal";

export function Eyebrow({ children, className = "" }) {
  return (
    <span className={`text-xs font-bold uppercase tracking-[0.2em] text-[#0B63F6] ${className}`}>
      {children}
    </span>
  );
}

export default function SectionHeading({ eyebrow, title, sub, align = "left", light = false, className = "" }) {
  const alignCls = align === "center" ? "items-center text-center mx-auto" : "items-start text-left";
  return (
    <div className={`flex flex-col ${alignCls} max-w-3xl ${className}`}>
      {eyebrow && (
        <Reveal>
          <Eyebrow>{eyebrow}</Eyebrow>
        </Reveal>
      )}
      {title && (
        <Reveal delay={0.05}>
          <h2 className={`font-display text-4xl lg:text-5xl font-bold tracking-tightest mt-4 leading-[1.05] ${light ? "text-white" : "text-[#111111]"}`}>
            {title}
          </h2>
        </Reveal>
      )}
      {sub && (
        <Reveal delay={0.1}>
          <p className={`text-lg mt-5 leading-relaxed ${light ? "text-[#A1A1AA]" : "text-gray-600"}`}>{sub}</p>
        </Reveal>
      )}
    </div>
  );
}
